module.exports = __webpack_public_path__ + "img/svg/ellipse.ae47bb21235c722caa91b711a53e2000.svg";